<template>
    <div class="error-wrapper" style="background-image: url(/statics/bg1.jpg)">
        <div>
            <h1 class="error-title">致命错误</h1>
            <p class="error-desc">请重新启动应用或联系管理员</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Error"
}
</script>

<style scoped lang="scss">
    .error-wrapper {
        overflow: hidden;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
    }

    .error-title {
        font-size: 120px;
        margin-left: 80px;
        margin-top: 9rem;
        font-weight: 700;
        color: #595d6e;
        margin-bottom: 0;
    }

    .error-desc {
        margin-top: 0;
        font-size: 22px;
        margin-left: 80px;
        color: #74788d;
    }
</style>
